/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var CatalogType;
(function (CatalogType) {
    CatalogType["MARKETING_SIF"] = "MARKETING_SIF";
    CatalogType["PRICEBOOK"] = "PRICEBOOK";
    CatalogType["CET_XML"] = "CET_XML";
})(CatalogType || (CatalogType = {}));
